<template>
  <div>
    <div v-if="schedule" id="booking-page">
      <!-- this is where we will inject the interface -->
    </div>
    <div id="instructions" style="display: none">
      <div class="container max-w-screen-md">
        <wavy-card>
          <div class="-mb-36">
            <div class="absolute left-0 right-0 top-0 flex justify-center">
              <div class="-mt-12 text-6xl">
                <img src="@/assets/brand/icon.svg" class="w-auto inline-block h-16 p-2.5 bg-brand-black rounded-full" alt="Logo" />
              </div>
            </div>
            <div class="mt-8 text-center">
              <p class="font-bold text-center text-brand-black text-2xl">We look forward to partnering with you!</p>
              <p class="font-semibold text-brand-brown text-center text-lg mt-1">
                Feel free to reach out via chat if you have any questions prior to our meeting. The button below will take you to the Churnkey
                builder. You can click around to get a feel for things, but we recommend holding off on setup until our implementation call.
              </p>
              <div class="mt-12">
                <el-button @click="goToBuilder" type="primary" class="text-lg font-semibold py-4">Look Around →</el-button>
              </div>
            </div>
          </div>
        </wavy-card>
      </div>
    </div>
  </div>
</template>

<script>
import WavyCard from '@/components/UI/WavyCard.vue';

window.addEventListener('savvycal.scheduled', (ev) => {
  const data = ev.detail;
  document.getElementById('instructions').style.display = 'block';
  document.getElementById('booking-page').style.display = 'none';
});

export default {
  name: 'OnboardDetails',
  components: {
    WavyCard,
  },
  data() {
    return {
      schedule: true,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  mounted() {
    // eslint-disable-next-line no-undef
    SavvyCal('inline', { link: 'churnkey-team/support', selector: '#booking-page' });
  },
  methods: {
    goToBuilder() {
      this.$router.push('/');
    },
  },
};
</script>
